import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Markdown from 'markdown-to-jsx'

// Components
import Modal from 'src/Components/shared/Modal'
import { Text } from 'src/Components'

import {
  selectCorporateProfile,
  selectCustomerDisclaimer,
  selectOfficeDisclaimer,
} from 'src/store/selectors/customerProfile'
import { toggleDisclaimer } from 'src/actions/layout'

const markdownPropTypes = {
  children: PropTypes.any,
  qa: PropTypes.string,
}

const MarkDownDiv = ({ children, qa }) => (
  <Text
    align='left'
    element='div'
    data-qa={qa}
    variant='neutralCool'
    variantCount='900'
  >
    <Markdown>{children}</Markdown>
  </Text>
)

const DisclaimerModal = () => {
  const dispatch = useDispatch()
  const corp = useSelector(state => selectCorporateProfile(state) || {})
  const { equalHousingType } = corp
  const custDisclaimer = useSelector(state => selectCustomerDisclaimer(state))
  const corpDisclaimer = corp.disclaimer
  const officeDisclaimer = useSelector(state => selectOfficeDisclaimer(state))

  return (
    <Modal
      title={
        <FormattedMessage
          id='DisclaimerModal.title'
          defaultMessage='Important Disclaimers'
        />
      }
      openKey='layout.showDisclaimer'
      toggle={() => dispatch(toggleDisclaimer())}
      level={4}
    >
      {custDisclaimer && (
        <>
          <MarkDownDiv qa='customerDisclaimer'>{custDisclaimer}</MarkDownDiv>
          <br />
        </>
      )}

      {officeDisclaimer && (
        <>
          <MarkDownDiv qa='officeDisclaimer'>{officeDisclaimer}</MarkDownDiv>
          <br />
        </>
      )}

      <Text
        align='left'
        data-qa='aprDisclaimer'
        variant='neutralCool'
        variantCount='900'
      >
        <FormattedMessage id='Disclaimer.bodyHTML' />
        {equalHousingType === 'lender' && 'Equal Housing Lender.'}
        {equalHousingType === 'opportunity' && 'Equal Housing Opportunity.'}
        {equalHousingType === 'equal_opportunity_lender' &&
          'Equal Opportunity Lender.'}
      </Text>
      {corpDisclaimer && (
        <>
          <br />
          <MarkDownDiv qa='companyDisclaimer'>{corpDisclaimer}</MarkDownDiv>
        </>
      )}
    </Modal>
  )
}

MarkDownDiv.propTypes = markdownPropTypes

export default DisclaimerModal
